define([
	"dojo/_base/declare",
	"csi/heading/Spec",
	"./_Processor"
], function(declare, Spec, _Processor) {

	return declare(_Processor, {
		restrictQuery: true,

		getColumnSpecs: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return column specifications for matrix
			var n = this._size(ctx, h);
			var specs = [];

			for (var i = 0; i < n; ++i) {
				specs.push(new Spec({
					index: i,
					heading: h,
					headerParams: {
						innerText: this._label(ctx, h, i)
					}
				}));
			}

			return specs;
		},

		_label: function(/*Context*/ctx, /*Heading*/h, /*Number*/index) {
			// summary: return column label for given index
			return h.getLabel(index);
		},

		_size: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return length of list for given attribute to indicate number of columns
			// to show - needs to be overridden if no node in context
			var node = ctx.getNode();
			var a = node ? node[h.m_id] : null;
			return a ? a.length : 0;
		}
	});
});